import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Badge, Icon, Navigation } from '@shopify/polaris';
import { AppsMajor, InviteMinor, CustomersMajor } from '@shopify/polaris-icons';
import NavigationSectionWrapper from './NavigationSectionWrapper';
import { APP_NAME, PLAN_OLD_FREE, PLAN_OLD_PRO } from '../constants/constants';
import NavigationMenuItemNew from './NavigationMenuItemNew';
import {
  HomeIcon,
  AnalyticsIcon,
  CampaignIcon,
  LanguageIcon,
  SettingsIcon,
  TemplatesIcon,
  WhatsAppExtensionIcon,
  WhatsAppWidgetIcon,
  WhatsAppManualMessageIcon,
  WhatsAppBusinessAccountIcon,
  CustomerIcon,
  ChatbotIcon,
  TeamInboxIcon,
  MessagingIcon,
  WalletIcon
} from './SvgIcons';
import NavigationMenuItemBadge from './NavigationMenuItemBadge';

const SideMenu = (props: any) => {
  const history = useHistory();
  const location = useLocation();
  const [features, setFeatures] = useState<string[]>([]);
  const [shop, setShop] = useState({
    id: '',
    url: '',
  });

  useEffect(() => {
    let f = localStorage.getItem('features');
    if (f) {
      setFeatures(f.split(','));
    }

    setShop(JSON.parse(localStorage.getItem('shop') || ''));
  }, [props.planId]);

  const changePath = (path: any) => {
    history.push(path);
  };

  const displayMenuEmail = () => {
    if (features.findIndex((el) => el === 'EMAIL') !== -1) {
      const subNavItems = [
        {
          label: 'Templates',
          onClick: () => changePath('/email-templates'),
          selected: location.pathname.includes('/email-templates'),
        },
        {
          label: 'Configuration',
          onClick: () => changePath('/email-config'),
          selected: location.pathname.includes('/email-config'),
        },
      ];
      const routes = ['/email-templates', '/email-config'];
      const path = location.pathname;
      return (
        <NavigationMenuItemNew
          parentActive={routes.some((el) => path.includes(el))}
          parentTitle='Email'
          parentIcon={InviteMinor}
          child={subNavItems}
        />
      );
    }
  };

  return (
    <Navigation location='/'>
      <div data-tut="homepage" id="homepage">
        <Navigation.Section
          key='homepage'
          items={[
            {
              onClick: () => changePath('/home'),
              url: '/',
              label: 'Home',
              icon: HomeIcon,
              selected: location.pathname.includes('/home'),
            },
          ]}
        />
      </div>
      {/* <div data-tut="sharedTeamInbox" id="sharedTeamInbox">
        <Navigation.Section
          key='Shared Team Inbox'
          items={[
            {
              onClick: () => changePath('/team-inbox'),
              url: '/',
              label: 'Shared Team Inbox',
              icon: TeamInboxIcon,
              selected: location.pathname.includes('/chat'),
              subNavigationItems: [
                {
                  onClick: () => changePath('/chat'),
                  url: '/chat',
                  label: 'Chat',
                },
                {
                  url: '/',
                  disabled: false,
                  label: 'Configuration',
                },
              ]
            },
          ]}
        />
      </div> */}
      <div data-tut="analyticsMessageLogs" id="analyticsMessageLogs">
        <Navigation.Section
          key='analyticsMessageLogs'
          items={[
            {
              onClick: () => changePath('/analytics-message-logs'),
              url: '/',
              label: 'Analytics & Logs',
              icon: AnalyticsIcon,
              selected: location.pathname.includes('/analytics-message-logs'),
            },
          ]}
        />
      </div>
      <div data-tut="campaigns" id="campaigns">
        <Navigation.Section
          key='Campaigns'
          items={[
            {
              onClick: () => changePath('/campaigns'),
              url: '/',
              label: 'Campaigns',
              icon: CampaignIcon,
              selected: location.pathname.includes('/campaigns'),
            },
          ]}
        />
      </div>
      <div data-tut="automation" id="automation">
        <Navigation.Section
          key='Automation'
          items={[
            {
              onClick: () => changePath('/templates'),
              url: '/',
              label: 'Automation',
              icon: TemplatesIcon,
              selected: location.pathname.includes('/templates'),
            },
          ]}
        />
      </div>
      <div data-tut="messaging" id="messaging">
        <Navigation.Section
          key='Messaging'
          items={[
            {
              onClick: () => changePath('/messaging'),
              url: '/',
              label: 'Messaging',
              icon: MessagingIcon,
              selected: location.pathname.includes('/messaging'),
            },
          ]}
        />
      </div>
      {/* <div data-tut="wallet" id="wallet">
        <Navigation.Section
          key='Wallet'
          items={[
            {
              onClick: () => changePath('/wallet'),
              url: '/',
              label: 'Wallet',
              icon: WalletIcon,
              selected: location.pathname.includes('/wallet'),
            },
          ]}
        />
      </div> */}
      <div data-tut="widgets" id="widgets">
        <NavigationMenuItemBadge
          to='/widget'
          label='Widgets'
          icon={WhatsAppWidgetIcon}
          badge='Free'
          selected={location.pathname.includes('/widget')}
        />
      </div>
      {![PLAN_OLD_FREE, PLAN_OLD_PRO].includes(Number(props.planId)) && (
        <>
          <div data-tut="customers" id="customers">
            <Navigation.Section
              key='customers'
              items={[
                {
                  onClick: () => changePath('/optins'),
                  url: '/',
                  label: 'Customers',
                  icon: CustomerIcon,
                  selected: location.pathname.includes('/optins'),
                },
              ]}
            />
          </div>
          <Navigation.Section
            key='admin-config'
            items={[
              {
                onClick: () => changePath('/admin-config'),
                url: '/',
                label: 'Settings',
                icon: SettingsIcon,
                selected: location.pathname.includes('/admin-config'),
              },
            ]}
          />
        </>
      )}
      <div data-tut="private-waba" id="private-waba">
        <Navigation.Section
          key='private-waba'
          items={[
            {
              onClick: () => changePath('/private-waba'),
              url: '/',
              label: 'My Whatsapp',
              icon: WhatsAppBusinessAccountIcon,
              selected: location.pathname.includes('/private-waba'),
            },
          ]}
          separator
        />
      </div>
      <div data-tut="teamInbox" id="teamInbox">
        <Navigation.Section
          key='team-inbox'
          items={[
            {
              onClick: () => changePath('/team-inbox'),
              url: '/',
              label: 'Shared Team Inbox',
              icon: TeamInboxIcon,
              selected: location.pathname.includes('/team-inbox'),
            },
          ]}
        />
      </div>
      <NavigationMenuItemBadge
        to='/chatbot'
        label='Chatbot'
        icon={ChatbotIcon}
        badge='New'
        selected={location.pathname.includes('/chatbot')}
      />
      {displayMenuEmail()}
      <NavigationSectionWrapper
        icon={LanguageIcon}
        label={<div id='google_translate_element'></div>}
      />
    </Navigation>
  );
};

export default SideMenu;